import { queryOptions } from "@tanstack/react-query";
import type { ServerDeploymentStatusResponse } from "@/app/servers/types";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { serversKeys } from "./query-keys";

const fetchDeploymentStatus = async (options: {
  client: ApiClient;
  serverId: string;
}): Promise<ServerDeploymentStatusResponse> => {
  const { client, serverId } = options;
  const { data } = await client.get<ServerDeploymentStatusResponse>(
    `/deployments/${serverId}/status`
  );
  return data;
};

export const getDeploymentStatusQueryOptions = ({
  serverId,
  binding = "project",
  activeInterval,
  stableInterval,
  scope,
}: {
  serverId: string;
  binding?: ScopedBinding;
  activeInterval: number;
  stableInterval: number;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<ServerDeploymentStatusResponse>({
    queryKey: serversKeys.deploymentStatus({ serverId, binding, scope }),
    queryFn: () => fetchDeploymentStatus({ client, serverId }),
    refetchInterval: (query) => {
      const data = query.state.data;
      if (!data) {
        return activeInterval;
      }

      const isActivelyDeploying =
        data.status === "pending" ||
        data.status === "updating" ||
        data.status === "unknown";
      return isActivelyDeploying ? activeInterval : stableInterval;
    },
  });
};
